<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form :form="form" layout="inline" :labelCol="{ style: { width: '70px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划名称" :help="null">
              <global-select
                v-decorator="['planName', { rules: [{ required: true }] }]"
                requestApi="/scp/scpMrpPlans/planNameBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2 }"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="计划版本" :help="null">
              <global-select
                v-decorator="['planVersion', { rules: [{ required: true }] }]"
                selectType="selectAssembleSearch"
                requestApi="/scp/scpMrpPlans/planVersionBox"
                :selectItem="{ value: 'realValue', label: 'label', thirdLabel: 'bringOutDataOne', thirdLabelText: '最新版本' }"
                :setParams="{ dataType: 2, planName: form.getFieldsValue().planName }"
                searchParam="planVersion"
                :allowClear="false"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="组织">
              <global-select
                v-decorator="['organizationCode', { initialValue: organizationCodeOrigin }]"
                requestApi="/scp/scpMrpPlans/planOrganizationBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ dataType: 2, planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="供应商">
              <global-select
                v-decorator="['supplierId']"
                selectType="select"
                requestApi="/scp/scpMrpBomStructures/supplierBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="计划员">
              <global-select
                v-decorator="['plannerCodeList']"
                selectType="selectMultiple"
                requestApi="/system/user/allJobCodeName"
                :selectItem="{ value: 'realValue', label: 'label' }"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-show="advanced">
            <a-form-item label="物料编码" :help="null">
              <global-select
                v-decorator="['itemIdList', { rules: [{ required: true }] }]"
                selectType="selectMultipleSearch"
                :focusGet="true"
                :selectData="itemIdListData"
                :dropdown-match-select-width="false"
                requestApi="/scp/scpMrpSystemItems/planItemsBox"
                :selectItem="{ value: 'realValue', label: 'label' }"
                :setParams="{ planName: form.getFieldsValue().planName, planVersion: form.getFieldsValue().planVersion, organizationCode: form.getFieldsValue().organizationCode || organizationCodeOrigin }"
                searchParam="label"
                sourseField="res"
                :totalNum="9999999999"
              />
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="handleQuery" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <a-button @click="handleExport" v-hasPermi="['scp:scpMrpBomStructures:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 2800 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.BOM_ASSEMBLY_LIST, // 表格方案配置唯一值
              }"
        >
          <template v-for="item in columns" :slot="item.dataIndex" slot-scope="{ text }">
            <div :key="item.dataIndex">
              <span v-if="item.type === 'text'">{{ text && $moment(text).format('YYYY-MM-DD HH:mm:ss') }}</span>
              <span v-else>{{ text }}</span>
            </div>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiScpMrpBomStructuresList } from '@/api/scp/mrp-result-query/bom-assembly'
import { generateLsTableResData } from '@/utils/util.js';

export default {
  // eslint-disable-next-line
  name: 'Bom-assembly', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {},
  data () {
    return {
       // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpMrpBomStructuresList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      // 查询参数
      form: this.$form.createForm(this),
      // 表格数据
      tableList: [],
      // 表格字段
      columns: [
        {
          title: '组织',
          dataIndex: 'organizationName',
          align: 'center',
          width: 140,
          ellipsis: true,
          stickyFixed: 'left'
        },
        {
          title: '供应商',
          dataIndex: 'supplierName',
          align: 'center',
          width: 140,
          ellipsis: true,
          stickyFixed: 'left'
        },
        {
          title: '装配件-物料编码',
          dataIndex: 'itemCode',
          align: 'center',
          width: 140,
          ellipsis: true,
          stickyFixed: 'left'
        },
        {
          title: '签价单',
          dataIndex: 'alternateBom',
          align: 'center',
          width: 170,
          ellipsis: true,
          stickyFixed: 'left'
        },
        {
          title: '装配件-物料名称',
          dataIndex: 'itemName',
          align: 'center'
        },
        {
          title: '装配件-规格描述',
          dataIndex: 'specification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '工序序号',
          dataIndex: 'operationSeqNum',
          align: 'center'
        },
        {
          title: '物料编码',
          dataIndex: 'componentItemCode',
          align: 'center'
        },
        {
          title: '物料名称',
          dataIndex: 'componentItemName',
          align: 'center'
        },
        {
          title: '规格描述',
          dataIndex: 'componentSpecification',
          align: 'center',
          ellipsis: true
        },
        {
          title: '单位用量',
          dataIndex: 'componentQuantity',
          align: 'center'
        },
        {
          title: '产出率',
          dataIndex: 'componentYieldFactor',
          align: 'center'
        },
        {
          title: '集采类型',
          dataIndex: 'centralizedPurchasingTypeName',
          align: 'center'
        },
        {
          title: '供应类型',
          dataIndex: 'wipSupplyTypeName',
          align: 'center'
        },
        {
          title: '生效日期',
          dataIndex: 'effectivityDate',
          scopedSlots: { customRender: 'effectivityDate' },
          align: 'center',
          type: "text"
        },
        {
          title: '失效日期',
          dataIndex: 'disableDate',
          scopedSlots: { customRender: 'disableDate' },
          align: 'center',
          type: "text"
        },
        {
          title: '计划名称',
          dataIndex: 'planName',
          align: 'center'
        },
        {
          title: '计划版本',
          dataIndex: 'planVersion',
          align: 'center'
        }
      ],
      itemIdListData: [] // 物料编码
    }
  },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  watch: {
    // 菜单和查询物料两个入口
    $route (to, from) {
      if (to.name !== "Bom-assembly") {
        return
      }
      if (Object.keys(this.$route.query).length > 0) {
        this.goNextHandle()
      } else {
        this.$nextTick(() => {
          this.form.resetFields()
        })
      }
    }
  },
  created () {
    // 从查询物料页面跳转过来，带过来的数据自动填充
    if (Object.keys(this.$route.query).length > 0) {
      this.goNextHandle()
    }
  },
  mounted () {},
  methods: {
    goNextHandle () {
      const obj = JSON.parse(this.$route.query.data)
      const arr = []
      const arr2 = []
      const arr3 = [{ realValue: "", label: "" }]
      obj.plannerCode && arr.push(obj.plannerCode)
      obj.itemId && arr2.push(obj.itemId)
      obj.plannerCodeList = arr
      obj.itemIdList = arr2
      arr3[0].realValue = obj.itemId
      arr3[0].label = obj.itemCode
      this.itemIdListData = arr3
      this.$nextTick(() => {
        this.form.setFieldsValue({
          planName: obj.planName,
          planVersion: obj.planVersion,
          organizationCode: obj.organizationCode,
          plannerCodeList: obj.plannerCodeList,
          itemIdList: obj.itemIdList
        })
        this.onSearch()
      })
    },
    // 表单搜索
    onSearch () {
      if (!this.form.getFieldsValue().planName) {
        this.$message.warning('计划名称不能为空')
        return;
      }
      if (!this.form.getFieldsValue().planVersion) {
        this.$message.warning('计划版本不能为空')
        return;
      }
      if (!this.form.getFieldsValue().itemIdList) {
        this.$message.warning('物料编码不能为空')
        return;
      }
      this.$refs.dataTable.searchParams = this.form.getFieldsValue();
      this.$refs.dataTable.getData();
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.form.resetFields()
      this.handleQuery()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 导出按钮操作 */
    handleExport () {
      this.download('scp/scpMrpBomStructures/export', {
        ...this.form.getFieldsValue()
      }, `BOM组件_${new Date().getTime()}.xlsx`)
    }
  }
}
</script>

<style scoped lang="less">
</style>
